const initFormModalComponent = () => {
    //the modal form component exists in just one instance
    const form = document.querySelector("[data-download-form]");
    const formModalComponent = document.querySelector("[data-form-modal-component]");
    const closeIcon = document.querySelector("[data-close-icon-form-download]");
    closeIcon.addEventListener("click", () => {
        formModalComponent.classList.remove("active");
    });
    const downloadCTAArray = document.querySelectorAll("[data-media-id]");
    downloadCTAArray && downloadCTAArray.length > 0 && downloadCTAArray.forEach(downloadCTA => {
        downloadCTA.addEventListener("click", (event) => {
            event.preventDefault();
            formModalComponent.classList.add("active");
            //Add id for specific media
            const mediaIDInput = form.querySelector("[data-media-id-target]");
            //Insert the correct media value inside hidden input
            mediaIDInput.value = downloadCTA.getAttribute("data-media-id");
        });
    });
};
